module.exports = __webpack_public_path__ + "img/3987201_s.31153286.jpg";